import * as React from 'react';
import { WITHOUT_RX, WITH_RX } from '../components/RxableSelect/contants.js';
import { useSunglassesProductData } from '../../../../context/product-context-hooks.js';
import { ChannelAvailability } from '../../../../types/product.js';

const SunglassesEcommContext = /*#__PURE__*/ React.createContext({});
const useSunglassesEcommContext = ()=>React.useContext(SunglassesEcommContext)
;
const SunglassesEcommProvider = ({ children ,  })=>{
    const { activeVariant: { channelAvailability  } , product: { isOfferedWithPrescriptions  } ,  } = useSunglassesProductData();
    const [selectWithRxLens, setSelectWithRxLens] = React.useState(WITHOUT_RX);
    var ref;
    const shouldOpenConfigurator = (ref = isOfferedWithPrescriptions && selectWithRxLens === WITH_RX) !== null && ref !== void 0 ? ref : false;
    const [isConfiguratorOpen, setIsConfiguratorOpen] = React.useState(false);
    const handleConfiguratorOpen = ()=>{
        setIsConfiguratorOpen(true);
    };
    const handleConfiguratorClose = ()=>{
        setIsConfiguratorOpen(false);
    };
    const productAction = React.useMemo(()=>{
        if (shouldOpenConfigurator) {
            return channelAvailability === ChannelAvailability.ONLINE ? 'OPEN_CONFIGURATOR' : 'OPEN_CONFIGURATOR_UNAVAILABLE';
        }
        return channelAvailability === ChannelAvailability.ONLINE ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE';
    }, [
        shouldOpenConfigurator,
        channelAvailability
    ]);
    const value = {
        productAction,
        selectWithRxLens,
        setSelectWithRxLens,
        isConfiguratorOpen,
        handleConfiguratorOpen,
        handleConfiguratorClose
    };
    return /*#__PURE__*/ React.createElement(SunglassesEcommContext.Provider, {
        value: value
    }, children);
};

export { SunglassesEcommContext, SunglassesEcommProvider, useSunglassesEcommContext };
//# sourceMappingURL=SunglassesEcommContext.js.map
